import styled from "styled-components";
import { colors, radius, spacing } from "design-system/foundation";
import { breakpoints } from "styles";

export const CameraContainer = styled.div`
  &,
  & *,
  & *::before,
  & *::after {
    box-sizing: border-box;
  }

  position: relative;
  width: calc(100% - ${spacing["4xl"]});
  margin: ${spacing.none} auto;
  aspect-ratio: 328 / 403;
  overflow: hidden;
  border-radius: ${radius.xl};

  @media ${breakpoints.tablet} {
    width: 100%;
    margin: ${spacing.none};
    aspect-ratio: 752 / 462;
  }
`;

export const CameraFrame = styled.div`
  position: absolute;
  inset: 3% 2%;
`;

export const CameraErrorContainer = styled.div`
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${spacing.xl};
  padding: ${spacing["2xl"]};
  background: ${colors.bg.base.default};
  text-align: center;
`;

export const CameraErrorText = styled.p`
  margin: ${spacing.none};
  color: ${colors.text.base.primary};
`;

export const Corner = styled.span<{ $position: string }>`
  position: absolute;
  width: 42px;
  height: 42px;
  border-color: ${colors.border.state.invert};
  border-style: solid;
  ${({ $position }) => $position.includes("top") && "top: 0;"}
  ${({ $position }) => $position.includes("bottom") && "bottom: 0;"}
  ${({ $position }) => $position.includes("Left") && "left: 0;"}
  ${({ $position }) => $position.includes("Right") && "right: 0;"}
  ${({ $position }) =>
    $position === "topLeft" &&
    `border-width: 3px 0 0 3px; border-top-left-radius: ${radius.sm};`}
  ${({ $position }) =>
    $position === "topRight" &&
    `border-width: 3px 3px 0 0; border-top-right-radius: ${radius.sm};`}
  ${({ $position }) =>
    $position === "bottomLeft" &&
    `border-width: 0 0 3px 3px; border-bottom-left-radius: ${radius.sm};`}
  ${({ $position }) =>
    $position === "bottomRight" &&
    `border-width: 0 3px 3px 0; border-bottom-right-radius: ${radius.sm};`}
`;

export const Countdown = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: ${colors.text.base.invert};
  font-weight: 700;
  font-family: Poppins, sans-serif;
  font-size: 200px;
  opacity: 0.8;
`;
